import Flickity from 'flickity'
import 'flickity-imagesloaded'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

const els = document.querySelectorAll('.element-leadership')

const sliders = []
const tickerSpeed = 1

export default {
  can: () => els.length,
  run: () => {
    const items = [
      ...Array.from(document.querySelectorAll('.page-header-headline p')),
      document.querySelector('.page-header-leadin'),
    ]

    items.forEach((item) => {
      gsap.set(item, {
        opacity: 0,
        y: '5%',
      })
    })

    gsap.to(items, {
      opacity: 1,
      y: 0,
      duration: 1.5,
      stagger: 0.5,
      paused: true,
      ease: 'power4',
      scrollTrigger: {
        trigger: document.querySelector('.page-header'),
        start: 'top 50%',
        markers: false,
      },
    })

    const teamMembers = Array.from(document.querySelectorAll('.element-leadership .team-member'))

    teamMembers.forEach((item) => {
      gsap.set(item, {
        opacity: 0,
        y: '5%',
      })
    })

    gsap.to(teamMembers, {
      opacity: 1,
      y: 0,
      duration: 1.5,
      stagger: 0.5,
      paused: true,
      ease: 'power4',
      scrollTrigger: {
        trigger: document.querySelector('.element-leadership'),
        start: 'top 70%',
        markers: false,
      },
    })

    els.forEach((el) => {
      if (!window.matchMedia('(max-width: 1023px)').matches) {
        return
      }

      const flickity = new Flickity(el.querySelector('.team-members'), {
        autoPlay: false,
        prevNextButtons: false,
        pageDots: false,
        draggable: true,
        wrapAround: true,
        imagesLoaded: true,
        selectedAttraction: 0.015,
        friction: 0.25,
      })

      const slider = {}

      slider.flickity = flickity
      slider.update = () => {
        flickity.x = (flickity.x - tickerSpeed) % flickity.slideableWidth
        flickity.selectedIndex = flickity.dragEndRestingSelect()
        flickity.updateSelectedSlide()
        flickity.settle(flickity.x)

        window.requestAnimationFrame(slider.update)
      }

      sliders.push(slider)
    })

    sliders.forEach((slider) => slider.update())
  },
}
